import type { AttachmentModel, OrderItemModel } from '@models/types'
import type { EntitiesState } from '@redux/entities'

type MimeTypes = {
  [key: string]: string,
}

export const mimeTypes: MimeTypes = {
  'image/png': 'image',
  'image/jpeg': 'image',
  'image/gif': 'image',
  'image/jpg': 'image',
  'application/pdf': 'pdf',
  'video/mp4': 'video',
}

export function getAttachmentType(attachment: Partial<AttachmentModel> = {}): string {
  const { file_content_type } = attachment

  return mimeTypes[file_content_type ?? ''] || 'unknown'
}

export function getFileSizeString(attachment: AttachmentModel) {
  const { dimensions, file_content_type, file_file_size } = attachment
  const { original: originalDimensions } = dimensions || {}
  const { width, height } = originalDimensions || {}

  const fileType = getAttachmentType(attachment)

  if (fileType === 'image' && width && height){
    return `${width}x${height}`
  }

  if (file_file_size){
    const megabytes = file_file_size / 1000000
    return `${Math.round(megabytes * 100) / 100} MB`
  }

  return file_content_type
}

type GroupProjectMediaParams = {
  attachments: EntitiesState['attachments'],
  campaignId: number,
  orderItems: EntitiesState['orderItems'],
}

type GroupedProjectMedia = {
  [key: number]: OrderItemModel & { attachmentIds: number[] },
}

export const groupProjectMedia = (params: GroupProjectMediaParams) => {
  const { attachments, campaignId, orderItems } = params

  const grouped: GroupedProjectMedia = {}

  Object.values(attachments).forEach((attachment) => {
    const { attachable_id, attachable_type, data } = attachment
    const { imported, outdated } = data || {}

    const orderItem = attachable_type === 'OrderItem' ? orderItems[attachable_id!] : undefined

    if (campaignId && orderItem?.campaign_id === campaignId && !imported && !outdated){
      const key = orderItem.id

      if (grouped[key]){
        grouped[key].attachmentIds.push(attachment.id)
      } else {
        // @ts-expect-error TS2322
        grouped[key] = orderItem
        grouped[key].attachmentIds = [attachment.id]
      }
    }
  })

  return Object.values(grouped)
}

type GenerateNavigationDataParams = {
  entities: { id: number, [key: string]: any }[],
  selectedId?: number,
}

export function generateNavigationData(params: GenerateNavigationDataParams) {
  const { entities = [], selectedId } = params

  const currentIndex = entities.findIndex(entity => entity.id === selectedId)

  const nextIndex = entities[currentIndex + 1] ? currentIndex + 1 : 0
  const nextId = entities[nextIndex] ? entities[nextIndex].id : selectedId

  const prevIndex = entities[currentIndex - 1] ? currentIndex - 1 : entities.length - 1
  const prevId = entities[prevIndex] ? entities[prevIndex].id : selectedId

  return {
    count: entities.length,
    currentId: selectedId,
    nextId,
    prevId,
  }
}

export default mimeTypes
